<template>
	<DrawerPanel
		ref="walkthrough-drawer"
		:title="walkthroughTitle"
		bottom="-95px"
		:blurBackground="true"
		:closeBackground="false"
		:openHeight="openHeight"
		closedHeight="0px"
		:startOpened="false"
		:divider="false"
		:contentAlwaysVisible="true"
		backgroundColor="#FFFFFF"
		openBackgroundColor="#FFFFFF"
		transitionDuration=".5s"
		@opened="handleDrawerOpened"
		@closed="handleDrawerClosed"
	>
		<MGWalkthrough
			:walkthroughData="walkthroughData"
			variant="sheet"
			:slideKey="slideKey"
			:height="determineCarouselHeight()"
			@slide-title-changed="handleTitleLoaded"
			@close="closeDrawer"
			@action-clicked="handleActionClicked"
			@close-drawer="closeDrawer"
		/>
	</DrawerPanel>
</template>

<script>
import DrawerPanel from './DrawerPanel.vue';
import MGWalkthrough from './MGWalkthrough.vue';

export default {
	name: 'WalkthroughDrawerPanel',
	emits: ['drawer-opened', 'drawer-closed', 'action-clicked'],
	components: {
		DrawerPanel,
		MGWalkthrough
	},
	props: {
		walkthroughData: {
			type: Object,
			required: true
		},
		slideKey: {
			type: String
		}
	},
	data() {
		return {
			walkthroughTitle: '',
			openHeight: '100%'
		}
	},
	mounted() {
		if (window.innerHeight < 700) {
			this.openHeight = 'calc(100vh + 10vh)';
		}
	},
	methods: {
		openDrawer() {
			this.$refs['walkthrough-drawer'].openDrawer();
		},
		closeDrawer() {
			document.body.classList.remove('hide-nav-bar');
			if (this.$refs['walkthrough-drawer']) {
				this.$refs['walkthrough-drawer'].closeDrawer();
			}
		},
		handleActionClicked(actionUri) {
			this.$emit('action-clicked', actionUri);
			this.closeDrawer();
		},
		handleTitleLoaded(title) {
			this.walkthroughTitle = title;
		},
		handleDrawerOpened() {
			document.body.classList.add('hide-nav-bar');
			this.$emit('drawer-opened');
		},
		handleDrawerClosed() {
			document.body.classList.remove('hide-nav-bar');
			this.$emit('drawer-closed');
		},
		determineCarouselHeight() {
			if (window.innerHeight < 700) {
				return '320px';
			} else {
				return '428px';
			}
		}
	}
};
</script>
